import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { ContactType } from '@/shared/lib/sj-orm/models/contact.dto';

export const useI18nValues = () => {
  const { t } = useTranslation('entities/contacts', { keyPrefix: 'types' });

  return useMemo(
    () => ({
      type: (type: ContactType) => t(i18nMap[type]),
    }),
    [t],
  );
};

const i18nMap = {
  [ContactType.BANK]: 'BANK',
  [ContactType.BROKER]: 'BROKER',
  [ContactType.INDIVIDUAL]: 'INDIVIDUAL',
  [ContactType.LEGAL_ENTITY]: 'LEGAL_ENTITY',
};
